<template>
  <div class="stage">
    <img :src="pageLoad" class="load" alt />
  </div>
</template>
<script>
import loading from "../../images/loading.gif";

export default {
  data() {
    return {
      pageLoad: loading
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.stage {
  text-align: center;
  background: transparent;
  .load {
    width: 120px;
    height: 120px;
    margin: auto;
  }
}
</style>